import { defineRecipe } from '@chakra-ui/react';

/**
 * Digitane AI Input Recipe
 * Custom input variants for chat and forms
 */

export const inputRecipe = defineRecipe({
  className: 'input',
  base: {
    width: '100%',
    outline: 'none',
    transition: 'all 0.2s',
    _disabled: {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  variants: {
    variant: {
      // Minimal/Unstyled variant for chat input
      unstyled: {
        bg: 'transparent',
        border: 'none',
        px: 0,
        py: 0,
        _focus: {
          outline: 'none',
          boxShadow: 'none',
        },
      },
      // Outline variant for forms
      outline: {
        border: '1px solid',
        borderColor: 'borders.default',
        borderRadius: 'md',
        px: 3,
        py: 2,
        bg: 'white',
        _focus: {
          borderColor: 'primary',
          boxShadow: 'focusRing',
        },
        _invalid: {
          borderColor: 'semantics.error',
        },
      },
    },
    size: {
      sm: {
        fontSize: 'sm',
        minH: 8,
      },
      md: {
        fontSize: 'md',
        minH: 10,
      },
      lg: {
        fontSize: 'lg',
        minH: 12,
      },
    },
  },
  defaultVariants: {
    variant: 'outline',
    size: 'md',
  },
});
